module.exports = __webpack_public_path__ + "img/39-min.a858edb5.jpg";